import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}


/**
 * Derive the commission rate (%) to display for a booking/payout/property.
 * Handles 0% correctly (which would be lost by `rec.commission_rate || 15`).
 * Falls back to deriving from platform_fee/total, then 15% default.
 */
export function getCommissionRate(rec) {
  if (rec?.commission_rate !== undefined && rec?.commission_rate !== null) {
    return rec.commission_rate;
  }
  if (rec?.platform_fee && rec?.total) {
    return Math.round((rec.platform_fee / rec.total) * 100);
  }
  return 15;
}
